import React from 'react'
import "./components.css"
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import UserImage from "../assets/user.png"

const UserConversation = ({ conversation }) => {
    const navigate = useNavigate()
    const user = useSelector((state) => state.auth.user)
    // console.log(conversation)

    // 1. Find the friend object specifically
    // Assuming members is an array of user objects with an _id field
    const friend = conversation.members.find((m) => m._id !== user._id)

    // 2. Fallback values in case data is missing
    const displayName = friend?.username || conversation.title || "Unknown User"
    const displayPic = friend?.profilePic || conversation?.profilePic || UserImage

    return (
        <div 
            className='chat-select' 
            onClick={() => navigate(`/chats/friends/${friend._id}`,{state:{partner:conversation.partner}})}
        >
            <div className="user-card-container">
                <div className="user-card-profile-image">
                    <img src={displayPic} alt='profile' />
                </div>
                <div className="user-profile-name">
                    <h3 className='user-card-name'>{displayName}</h3>
                </div>
            </div>
        </div>
    )
}

export default UserConversation